module.exports = __webpack_public_path__ + "static/img/2.b4ac7ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/2.png
// module id = 1e1d
// module chunks = 1